var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDebit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4691 6.86339L13.1361 0.530141C12.7942 0.18829 12.3383 0 11.8523 0C11.3663 0 10.9104 0.188212 10.5685 0.530063L0.530117 10.5689C0.188281 10.9108 0 11.3667 0 11.8527C0 12.3388 0.188281 12.7947 0.530117 13.1365L1.31105 13.9175L6.55992 19.1666H3.88876C3.65868 19.1666 3.47212 19.3531 3.47212 19.5833C3.47212 19.8134 3.65868 19.9999 3.88876 19.9999H8.14528L8.14688 20L8.14848 19.9999L12.4995 20C12.7296 20 12.9161 19.8134 12.9161 19.5833C12.9161 19.3532 12.7296 19.1667 12.4995 19.1667L9.73399 19.1666L19.4691 9.43101C20.177 8.72309 20.177 7.57124 19.4691 6.86339ZM18.8799 8.84176L8.84145 18.8807C8.65734 19.0647 8.41125 19.1662 8.1484 19.1666H8.14524C7.88246 19.1662 7.63645 19.0647 7.45242 18.8807L1.1193 12.5473C0.934883 12.3629 0.83332 12.1162 0.83332 11.8528C0.83332 11.5893 0.934883 11.3426 1.11934 11.1582L11.1577 1.11935C11.3422 0.934925 11.5888 0.833358 11.8523 0.833358C12.1157 0.833358 12.3624 0.934925 12.5468 1.11939L13.412 1.98458L1.71261 13.6846L2.85738 14.8294L14.5567 3.12942L18.8799 7.4526C19.2628 7.83559 19.2628 8.45878 18.8799 8.84176Z",
    fill: "#505767"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.099 11.4786C10.9363 11.3159 10.6725 11.3159 10.5097 11.4786L7.23103 14.7574C7.06834 14.9201 7.06834 15.1839 7.23103 15.3467C7.3124 15.428 7.41904 15.4687 7.52564 15.4687C7.63225 15.4687 7.73889 15.428 7.82025 15.3467L11.0989 12.0679C11.2617 11.9051 11.2617 11.6413 11.099 11.4786Z",
    fill: "#505767"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2656 7.31192C15.1029 7.14922 14.8392 7.14926 14.6764 7.31192L13.3421 8.64626C13.1794 8.80896 13.1794 9.07276 13.3421 9.23554C13.4235 9.31691 13.5302 9.35758 13.6368 9.35758C13.7434 9.35758 13.85 9.31687 13.9314 9.23554L15.2656 7.9012C15.4283 7.73842 15.4283 7.47462 15.2656 7.31192Z",
    fill: "#505767"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDebit);
export default __webpack_public_path__ + "static/media/debit.68d459353cf8b246eb6305aadcc4fd27.svg";
export { ForwardRef as ReactComponent };